import { publicClient, privateClient } from './client';
import { PhysicalStore } from './PhysicalStore';

const customPhysicalStore = (pub: boolean) => new PhysicalStore(pub ? publicClient : privateClient);
export default customPhysicalStore;
